<template>

  <div>
    <b-card no-body>
      <b-card-body fluid="xl">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="From Date" label-for="fromdate">
                <b-form-datepicker
                  id="fromdate"
                  name="fromdate"
                  :min="form.todate?form.todate:min"
                  :state="validateState('fromdate')"
                  v-model.trim="$v.form.fromdate.$model"
                  aria-describedby="liveFeedbackFromDate"
                  placeholder="DD/MM/YYYY"
                  today-button
                  reset-button
                  close-button
                  autofocus
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />

              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackFromDate">Please enter From Date</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="To Date" label-for="todate">
                <b-form-datepicker
                  id="todate"
                  name="todate"
                  :min="form.fromdate?form.fromdate:min"
                  :state="validateState('todate')"
                  v-model.trim="$v.form.todate.$model"
                  aria-describedby="liveFeedbackToDate"
                  placeholder="DD/MM/YYYY"
                  today-button
                  reset-button
                  close-button
                  autofocus
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackToDate">Please enter To Date</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <h4>Total Days: {{totalDays}}</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="mw3">
              <b-button @click="saveDates" :disabled="$v.form.$invalid || $v.form.fromdate.$model > $v.form.todate.$model">Submit</b-button>
            </b-col>
            <b-col cols="6" class="mw3">
              <b-button @click="onCancel">Cancel</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

  import Vue from 'vue';
  import { required } from 'vuelidate/lib/validators';
  import { validationMixin } from "vuelidate";
  import moment from 'moment'


  const datesShape = {
    fromdate: null,
    todate: null
  }
  export default {
    mixins: [validationMixin],
    name: 'FromToDatePrdModal',
    props: {
      product: Object
    },

    data: function() {
      return {
        form: Object.assign({}, datesShape),
        min: new Date(),


      }
    },
    validations: {
      form: {
        fromdate: {
          required
        },
        todate: {
          required
        }
      }
    },
    computed: {
      totalDays(){
        if(this.form.fromdate == null || this.form.todate == null){
          return 0;
        }
        const startdate = moment(new Date(this.form.fromdate));
        const enddate = moment(new Date(this.form.todate));
        return enddate.diff(startdate, 'days') + 1;
      },
      isValid() {
        var tempNewStart = new Date(this.form.fromdate);
        var tempNewEnd = new Date(this.form.todate);
        console.log(tempNewStart);
        console.log(tempNewEnd);
        if(tempNewStart > tempNewEnd || tempNewEnd < tempNewStart){
          this.showErrorMsg({
            message:
              'From Date must be less than To Date.'
          })
          return false;
        }
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      isDirty() {
        return this.$v.form.$anyDirty
      }
    },
    methods: {
      onCancel() {
        this.form = Object.assign({}, datesShape)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.$emit('cancel')
      },
      saveDates() {

        if (this.isValid) {
          var newProduct = JSON.parse(JSON.stringify(this.product))
          newProduct.fromdate = new Date(this.form.fromdate);
          newProduct.todate = new Date(this.form.todate);
          if(this.product.updateDates == true){
            this.$emit('updatesuccess', newProduct)
          }
          else{
            this.$emit('success', newProduct)
          }
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name]
        return $dirty ? !$error : null
      }
    },
    created() {
      if (this.product !== null) {
        this.form.fromdate = this.product.fromdate;
        this.form.todate = this.product.todate;
      }
    }
  }

</script>

<style>

</style>
